module.exports = __webpack_public_path__ + "img/59.d959d466.jpg";